import { SearchCompaniesQueryResponse } from '../../../../../../types/api/endpoints/companies/searchCompany.types';
import { COMPANY_ENDPOINTS } from '../../../../../../utils/api/endpoints/companyEndpoints';
import { SearchCompaniesQuery } from './DashboardCompaniesTable.types';

const SEARCH_PREFIX = '[searchCompaniesQuery]';

export const SEARCH_COMPANIES_QUERY_KEY = 'SEARCH_COMPANIES';

export const searchCompaniesQuery = async ({
  search,
  params: { page = 1, perPage = 25, domains, fieldsOfActivity, region, department },
}: SearchCompaniesQuery) => {
  console.log(SEARCH_PREFIX, `Fetching search companies...`);

  const response = await COMPANY_ENDPOINTS.searchConfirmed(search, {
    page,
    perPage,
    domains,
    fieldsOfActivity,
    region,
    department,
  });

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(SEARCH_PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(SEARCH_PREFIX, `Fetched search companies.`);
  return json as SearchCompaniesQueryResponse;
};
